import { Component,useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


const TestComponent=(props)=>{
  const [form,setForm] = useState({
    firstName:"",
    lastName:""
  })
  function handleChange(e){
    setForm((prev)=>({...prev, [e.target.name]: e.target.value}))
  }

  return (
    <div>
      <input name="firstName" onChange={handleChange} value={form.firstName}/>
      <input name="lastName" onChange={handleChange} value={form.lastName}/>
    <h4>First Name: {form.firstName}</h4>
    <h4>Last Name: {form.lastName}</h4>
    </div>

  );
}
  
  export default TestComponent;

